import { store } from "../store";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type IState = RootState;

export enum IncidentStatusEnum {
    INVESTIGATING = "investigating",
    IDENTIFIED = "identified",
    MONITORING = "monitoring",
    RESOLVED = "resolved",
}

export enum IncidentLevelEnum {
    SUCCESS = "success",
    WARNING = "warning",
    DANGER = "danger",
}

export const incidentLevelPriority: Record<IncidentLevelEnum, number> = {
    [IncidentLevelEnum.SUCCESS]: 0,
    [IncidentLevelEnum.WARNING]: 1,
    [IncidentLevelEnum.DANGER]: 2,
};

export type IncidentType = {
    components: ApiComponentType[];
    description: string;
    id: string;
    level: IncidentLevelEnum;
    name: string;
    updatedAt: string;
    index: number;
};

export type ApiComponentType = {
    created_at: string;
    description: string;
    components?: string | string[];
    group: boolean;
    group_id: null | string;
    id: string;
    name: string;
    only_show_if_degraded: boolean;
    page_id: string;
    position: number;
    showcase: boolean;
    start_date: string;
    status: ComponentStatusEnum;
    updated_at: string;
};

export type GroupedComponents = {
    [key: string]: ApiComponentType[];
};

export type ApiIncidentType = {
    created_at: string;
    id: string;
    impact: string;
    components: ApiComponentType[];
    incident_updates: [
        {
            body: string;
            created_at: string;
            display_at: string;
            id: string;
            incident_id: string;
            status: string;
            updated_at: string;
        },
    ];
    monitoring_at: null | string;
    name: string;
    page_id: string;
    resolved_at: null | string;
    shortlink: string;
    status: string;
    updated_at: string;
    started_at: null | string;
};

export enum ComponentStatusEnum {
    OPERATIONAL = "operational",
    UNDER_MAINTENANCE = "under_maintenance",
    DEGRADED_PERFORMANCE = "degraded_performance",
    PARTIAL_OUTAGE = "partial_outage",
    MAJOR_OUTAGE = "major_outage",
    SECURITY_EVENT = "security_event",
}

export enum ScheduledMaintenanceEnum {
    SCHEDULED = "scheduled",
    IN_PROGRESS = "in_progress",
    VERIFYING = "verifying",
    COMPLETED = "completed",
}

export type ApiStatusType = {
    description: string;
    indicator: string;
};

export type ApiPageType = {
    id: string;
    name: string;
    time_zone: string;
    updated_at: string;
    url: string;
};

export type ApiScheduledMaintenanceType = {
    created_at: string;
    id: string;
    impact: string;
    components: ApiComponentType[];
    incident_updates: [
        {
            body: string;
            created_at: string;
            display_at: string;
            id: string;
            incident_id: string;
            status: ScheduledMaintenanceEnum;
            updated_at: string;
            affected_components: ApiComponentType[] | null;
        },
    ];
    monitoring_at: null | string;
    name: string;
    page_id: string;
    resolved_at: null | string;
    scheduled_for: string;
    scheduled_until: string;
    shortlink: string;
    status: string;
    updated_at: string;
};
